import React, { useEffect, useState } from "react";
import { CustomGetAPI, CustomPostAPI } from "../Utils/APIConnector";
import VenueList from "./VenueList";
import VenueOwnerDashboard from "./VenueOwnerDashboard";
import { Dropdown } from "react-bootstrap";
import VenueOwnerOfflineBooking from "../Popup/VenueOwnerOfflineBooking";
import { formatDateToInput } from "../Utils/common";
import { useNavigate } from "react-router-dom";
import AdminVenueList from "./AdminVenueList";
import VenueOwnerDashbooardBooking from "./VenueOwnerDashbooardBooking";
import VenueOwnerBookingPage from "../Popup/VenueOwnerBookingPage";
import _ from "lodash";
import { useCallback } from "react";

export default function VenueOwnerHome() {
  const [venuesData, setVenuesData] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isHomePage, setIsHomePage] = useState(true);
  const [activeLink, setActiveLink] = useState("booking");
  const userID = localStorage.getItem("userid");
  const UserMobileNo = localStorage.getItem("UserMobileNo");
  const [venueName, setVenueName] = useState("");
  const [venueStatus, setVenueStatus] = useState("0");
  const [venueDetails, setVenueDetails] = useState();
  const [activeCourt, setActiveCourt] = useState("All");
  const [activeCourtID, setActiveCourtId] = useState(0);
  const [activeCalendarID, setCalendarCourtId] = useState(0);
  const [dateid, setDateid] = useState(0);
  const [startDate, setStartDate] = useState(formatDateToInput(new Date()));
  const [endDate, setEndDate] = useState(formatDateToInput(new Date()));
  const [HasMore, setHasMore] = useState(false);
  const [PageNumber, setPageNumber] = useState(1);
  const UserType = localStorage.getItem("UserType");
  const navigate = useNavigate();
  const [showoffline, setShowoffline] = useState({
    popup: false,
    data: "",
    title: "",
    date: new Date(),
  });
  const [isMainPage, setIsMainPage] = useState(true);
  const [showPlanDetails, setShowPlanDetails] = useState(false);
  const [venuePlanDetials, setVenuePlanDetails] = useState();
  const [venueOwnerPlans, setVenueOwnerPlans] = useState([]);

  useEffect(() => {
    if (selectedVenue > 0) getPlanDetails();
  }, [selectedVenue]);

  const getPlanDetails = async () => {
    try {
      await CustomGetAPI(
        `/VenueOwnerPlan/GetVenuePackages/${selectedVenue}`
      ).then((result) => {
        result = JSON.parse(result);
        if (result?.status == "Success") {
          setVenuePlanDetails(result?.data);
          setVenueOwnerPlans(result?.venueownerplan);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    DashboardFun();
  }, [
    selectedVenue,
    dateid,
    activeCourtID,
    activeCalendarID,
    startDate,
    endDate,
    showoffline?.popup,
    activeLink
  ]);

  const DashboardFun = () => {
    if (selectedVenue != 0 && activeLink == "dashboard") {
      setIsLoading(true);
      const raw = JSON.stringify({
        venueId: selectedVenue,
        dateid: dateid,
        CourtId: activeCourtID,
        CalenderId: activeCalendarID,
        Startdate: startDate,
        Enddate: endDate,
      });
      CustomPostAPI("/venue/Dashboard", raw).then((result) => {
        if (result) {
          result = JSON.parse(result);
          if (result.status === "Success") {
            setIsLoading(false);
            setVenueDetails(result?.response);
          }
        }
      });
    } else {
      setIsLoading(false);
    }

  };
  useEffect(() => {
    getVenue();
  }, []);

  const delayedSearch = useCallback(
    _.debounce(async (val) => {
      try {
        setPageNumber(1);
        setVenuesData([]);
        getVenue(val, true, venueStatus);
      } catch (error) {
        // console.log(error);
      }
    }, 500),
    [venueStatus]
  );
  const handleSelectCourt = (index, id) => {
    if (index >= 0 && index < venueDetails?.surfaces?.length) {
      setActiveCourt(venueDetails?.surfaces[index]?.courtName);
      setActiveCourtId(venueDetails?.surfaces[index]?.id);
    } else {
      setActiveCourt("All");
      setActiveCourtId(0);
    }
  };
  // const windowWidth = window.innerWidth;
  const getVenue = async (val, isSearch, status) => {
    // const timingIds = filterObjects?.timings.map((timing) => timing.value);
    try {
      const raw = JSON.stringify({
        pageNumber: isSearch || status ? 1 : PageNumber,
        pageSize: 10,
        venueName: isSearch ? val : venueName,
        venueStatus: parseInt(status ? status : venueStatus),
      });
      await CustomPostAPI(
        `/Venue/NewGetUserCreatedVenues/${userID ? userID : "0"}`,
        raw
      ).then((result) => {
        if (result === undefined || result === "") {
          alert("Something went wrong");
        } else {
          result = JSON.parse(result);
          // console.log(result);
          setHasMore(result?.hasNext);
          setPageNumber((prevPage) => prevPage + 1);
          setVenuesData((prevData) => [...prevData, ...result?.venues]);
          // setFilterData(result.venues);
          const activeVenues = result?.venues;
          // const activeVenues = result?.venues?.filter(
          //   (item) => item?.isAcrive == 4 || item?.isAcrive == 5
          // );
          if (
            activeVenues?.length == 1 &&
            UserType !== "Admin" &&
            PageNumber == 1 &&
            venueStatus == "0" &&
            venueName == ""
          ) {
            setIsLoading(true);
            setSelectedVenue(activeVenues[0]?.id);
            setVenueName(activeVenues[0]?.name);
            setActiveCourtId(activeVenues[0]?.surfaces[0]?.venuesportID);
            setIsHomePage(false);
            window.scrollTo(0, 0);
            setActiveCourt("All");
            setDateid(0);
            setEndDate(formatDateToInput(new Date()));
            setStartDate(formatDateToInput(new Date()));
            // setShowoffline((prev) => ({ ...prev, popup: true }));
          }
        }
      });
    } catch (error) {
      console.error("NewGetAllVenues: ", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(async () => {
  //   await CustomGetAPI(
  //     `/Venue/NewGetUserCreatedVenues/${userID ? userID : "0"}`
  //   ).then((result) => {
  //     if (result === undefined || result === "") {
  //       alert("Something went wrong");
  //     } else {
  //       result = JSON.parse(result);
  //       setIsLoading(false);
  //       setVenuesData(result?.venues);
  //       const activeVenues = result?.venues?.filter(
  //         (item) => item?.isAcrive == 4 || item?.isAcrive == 5
  //       );
  //       if (activeVenues?.length == 1) {
  //         setIsLoading(true);
  //         setSelectedVenue(activeVenues[0]?.id);
  //         setActiveCourtId(activeVenues[0]?.surfaces[0]?.venuesportID);
  //         setIsHomePage(false);
  //         window.scrollTo(0, 0);
  //         setActiveCourt("All");
  //         setDateid(0);
  //         setEndDate(formatDateToInput(new Date()));
  //         setStartDate(formatDateToInput(new Date()));
  //         // setShowoffline((prev) => ({ ...prev, popup: true }));
  //       }
  //     }
  //   }, []);
  // }, []);
  return (
    <React.Fragment>
      {showoffline?.popup && (
        <>
          <VenueOwnerOfflineBooking
            showoffline={showoffline}
            setShowoffline={setShowoffline}
            VenueId={selectedVenue}
          />
        </>
      )}
      <>
        <div
          style={{
            position: isHomePage || UserType === "Staff" ? "" : "sticky",
            width:
              isHomePage || UserType === "Staff"
                ? ""
                : "-webkit-fill-available",
            zIndex: isHomePage || UserType === "Staff" ? "" : "2",
          }}
          className={`row  pt-3 mx-0 ${isHomePage || UserType === "Staff"
            ? "px-0"
            : "px-2 dashboardHeaderBg"
            }`}
        >
          <div className="col-1">
            <img
              src="/images/backArrow.svg"
              onClick={() => {
                if (showPlanDetails) {
                  setShowPlanDetails(false);
                  return;
                }
                if (!isMainPage) {
                  setIsMainPage(true);
                } else {
                  isHomePage
                    ? (window.location = "/home")
                    : setIsHomePage(true);
                  setSelectedVenue(0);
                  setVenueName("");

                }
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
          {isHomePage && !isLoading ? (
            <div className="col-11 ps-0 text-center">
              <h1 className="venueListHeader">Venue Lists</h1>
            </div>
          ) : (
            <>
              {UserType === "Staff" ? (
                <>
                  {selectedVenue > 0 && activeCourtID > 0 && (
                    <VenueOwnerDashbooardBooking
                      selectedVenue={selectedVenue}
                      setIsLoading={setIsLoading}
                      isLoading={isLoading}
                      activeCourtID={activeCourtID}
                      showoffline={showoffline}
                      viewType={2}
                      setShowoffline={setShowoffline}
                    />
                  )}
                </>
              ) : (
                <div className="col-11 text-start">
                  <h1 className="venueListHeader">{venueDetails?.venuename || venueName}</h1>
                  {/* <div className="row mx-0 d-flex align-items-center ">
                      <div className="col-12 d-flex justify-content-between">
                        {" "}
                        <div className="">
                          <h1 className="venueListHeader">
                            {venueDetails?.venuename}
                          </h1>
                        </div>
                        {venueDetails?.surfaces?.length > 1 && (
                          <div className="d-none">
                            <Dropdown
                              className="custom-dropdown"
                              onSelect={handleSelectCourt}
                            >
                              <Dropdown.Toggle
                                as="div"
                                className="fw-semibold cursor-pointer"
                                style={{ color: "#a51e22" }}
                              >
                                {activeCourt ? activeCourt : "All"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="custom-dropdown-menu">
                                <Dropdown.Item
                                  id={0}
                                  active={activeCourt === "All"}
                                >
                                  All
                                </Dropdown.Item>
                                {venueDetails?.surfaces?.map((court, index) => (
                                  <Dropdown.Item
                                    key={index}
                                    eventKey={index}
                                    id={court?.id}
                                    active={court?.courtName === activeCourt}
                                  >
                                    {court?.courtName}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        )}
                      </div>
                      <div className="col-5 d-none">
                        <button
                          className="VenueOwnerBookOfflineBtn w-100 py-2"
                          onClick={(e) => {
                            setShowoffline({
                              date: new Date(),
                              popup: true,
                              data: "",
                              title: "Book Your Venue Offline",
                            });
                          }}
                        >
                          New Booking
                        </button>
                      </div>
                    </div> */}
                </div>
              )}
            </>
          )}
        </div>
        <div
          className="row mx-0"
          style={{
            position: isHomePage || UserType === "Staff" ? "" : "sticky",
            width:
              isHomePage || UserType === "Staff"
                ? ""
                : "-webkit-fill-available",
            zIndex: isHomePage || UserType === "Staff" ? "" : "2",
            top: "7%",
          }}
        >
          {isHomePage ? (
            <>
              {UserType === "Admin" ? (
                <>
                  <p
                    className="adminText cursor-pointer text-center pe-2 m-0"
                    style={{ color: "#a51e22" }}
                    onClick={() => navigate("/all-listed-venues")}
                  >
                    <b> View All Venues</b>
                  </p>
                  <AdminVenueList
                    venuesData={venuesData}
                    setVenuesData={setVenuesData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setIsHomePage={setIsHomePage}
                    setSelectedVenue={setSelectedVenue}
                    getVenue={getVenue}
                    HasMore={HasMore}
                  />
                </>
              ) : (
                <>
                  {UserMobileNo && UserMobileNo == "0000000000" && (
                    <div className="col-12">
                      {" "}
                      <div className="row mt-4">
                        <div className="col-8">
                          <input
                            type="text"
                            value={venueName}
                            onChange={(e) => {
                              setVenueName(e.target.value);
                              setIsLoading(true);
                              delayedSearch(e.target.value);
                            }}
                            className="form-control py-1"
                            placeholder="VenueName"
                          />
                        </div>
                        <div className="col-4">
                          <select
                            className="form-select py-0"
                            value={venueStatus}
                            onChange={(e) => {
                              setVenueStatus(e.target.value);
                              setPageNumber(1);
                              setIsLoading(true);
                              setVenuesData([]);
                              getVenue(venueName, false, e.target.value);
                            }}
                          >
                            <option value={0}>All</option>
                            <option value={1}>Active</option>
                            <option value={2}>Pending</option>
                            <option value={3}>Disabled</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  )}
                  <VenueList
                    venuesData={venuesData}
                    setVenuesData={setVenuesData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setIsHomePage={setIsHomePage}
                    setSelectedVenue={setSelectedVenue}
                    setActiveCourt={setActiveCourt}
                    setActiveCourtId={setActiveCourtId}
                    setDateid={setDateid}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    setShowoffline={setShowoffline}
                    getVenue={getVenue}
                    HasMore={HasMore}
                    setVenueName={setVenueName}
                  />
                </>
              )}
            </>
          ) : (
            <>
              {UserType === "Staff" ? (
                <></>
              ) : (
                <VenueOwnerDashboard
                  selectedVenue={selectedVenue}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  setVenueDetails={setVenueDetails}
                  venueDetails={venueDetails}
                  setDateid={setDateid}
                  dateid={dateid}
                  activeCalendarID={activeCalendarID}
                  setCalendarCourtId={setCalendarCourtId}
                  setStartDate={setStartDate}
                  startDate={startDate}
                  setEndDate={setEndDate}
                  endDate={endDate}
                  activeCourtID={activeCourtID}
                  showoffline={showoffline}
                  setIsMainPage={setIsMainPage}
                  isMainPage={isMainPage}
                  setShowoffline={setShowoffline}
                  venuePlanDetials={venuePlanDetials}
                  setVenuePlanDetails={setVenuePlanDetails}
                  showPlanDetails={showPlanDetails}
                  setShowPlanDetails={setShowPlanDetails}
                  getPlanDetails={getPlanDetails}
                  venueOwnerPlans={venueOwnerPlans}
                  DashboardFun={DashboardFun}
                  activeLink={activeLink}
                  setActiveLink={setActiveLink}
                />
              )}
            </>
          )}
        </div>
      </>
    </React.Fragment>
  );
}
